export enum KisweFont {
  Arial = 'Arial',
  TimesNewRoman = 'Times New Roman',
  WorkSans = 'Work Sans',
  Paris2024 = 'Paris2024'
}
